import * as React from 'react'
import { useIntl } from 'react-intl'
import SolidStarIcon from 'LuxKit/Icons/solid/SolidStarIcon'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import { TrustPilotLogo } from 'components/Common/TrustIndicators/TrustPilotLogo'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'

const CardContainer = styled(Group)`
  width: 75vw;

  ${mediaQueryUp.tablet} {
    width: ${rem(320)};
  }
`

export interface FiveStarReview {
  content: string
  name: string
  regionCode?: string
  source: 'trustpilot' | 'google'
}

function ReviewCard({
  content,
  name,
  regionCode,
  source,
}: FiveStarReview): React.ReactElement {
  const intl = useIntl()
  const regionLabel = regionCode
    ? new Intl.DisplayNames(intl.locale, { type: 'region' }).of(regionCode) ?? regionCode
    : undefined
  const displayName = regionLabel ? intl.formatMessage(
    {
      id: '3AZIYKWJzFZKah1oUEJv',
      defaultMessage: '{name}, {region}',
      description: 'Reviewer name with their region in the guest reviews section',
    },
    { name, region: regionLabel },
  ) : name

  return (
    <CardContainer direction="vertical" gap={16}>
      <Group direction="horizontal" gap={4}>
        <SolidStarIcon size="S" />
        <SolidStarIcon size="S" />
        <SolidStarIcon size="S" />
        <SolidStarIcon size="S" />
        <SolidStarIcon size="S" />
      </Group>
      <BodyText variant="large">{content}</BodyText>
      <Group direction="horizontal" verticalAlign="center" gap={8}>
        <BodyText variant="large" weight="bold">{displayName}</BodyText>
        <BodyText variant="large" weight="bold">{intl.formatMessage(middleDotSeparatorMessage)}</BodyText>
        {source == 'google' && <GoogleLongLogo width="54" height="18" />}
        {source == 'trustpilot' && <TrustPilotLogo width="78" height="18" />}
      </Group>
    </CardContainer>
  )
}

export default ReviewCard
